import I18nProvider, { I18nContext } from './I18nProvider';

export { I18nContext };
export default I18nProvider;
